import { render, staticRenderFns } from "./Section2.vue?vue&type=template&id=6273bcd0&scoped=true&"
var script = {}
import style0 from "./Section2.vue?vue&type=style&index=0&id=6273bcd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6273bcd0",
  null
  
)

export default component.exports